import _ from 'lodash';
import React from 'react';

export default function Tabs({selectedTab, changeHandler}) {
  const switchTab = (selectedTabName) =>
    changeHandler({type: 'changeTab', value: selectedTabName});

  const tabClasses = {
    style: 'inline-panel-tab',
    action: 'inline-panel-tab',
  };

  tabClasses[selectedTab] += ' selected';

  return (
    <div className='tab-container'>
      <div
        onClick={_.partial(switchTab, 'style')}
        className={tabClasses.style}
      >
        Style
      </div>
      <div
        onClick={_.partial(switchTab, 'action')}
        className={tabClasses.action}
      >
        Action
      </div>
    </div>
  );
}

Tabs.propTypes = {
  selectedTab: React.PropTypes.oneOf(['style', 'action']).isRequired,
  changeHandler: React.PropTypes.func.isRequired,
};



// WEBPACK FOOTER //
// ./src/ui/inline-text/tabs.jsx